module.exports = __webpack_public_path__ + "317102f7677ea37837d96f1ae1f00dc9.MP3";